import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { getRichTextHtml } from '@msdyn365-commerce/core-internal';

// Function logic copied from Microsoft to maintain same formatting
const getHtmlString = (content: string) => {
    const _isHTMLString = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
    if (_isHTMLString(content)) {
        return getRichTextHtml(content) ?? undefined;
    } else {
        var array = content
            ?.split('- ')
            .join('')
            .split('\\n')
            .join('\n')
            .split('\n');
        const htmlContent = {
            __html: array?.map((item: string) => `<p>${item}</p>`).join('')
        };
        return htmlContent;
    }
};

export interface CollapsibleItemData {
    id: string;
    title: string;
    content: ReactNode;
    defaultOpen?: boolean;
    renderAsHtml?: boolean;
    appendedContent?: ReactNode;
}
interface CollapsibleItemProps {
    item: CollapsibleItemData;
    isOpen: boolean;
    onToggle: (id: string) => void;
}
const CollapsibleItem = ({ item, isOpen, onToggle }: CollapsibleItemProps) => {
    return (
        <div className='bs-collapsible-item'>
            <button
                className='bs-collapsible-item__trigger'
                type='button'
                aria-expanded={isOpen}
                aria-controls={`${item.id}-content`}
                onClick={() => onToggle(item.id)}
            >
                <span>{item.title}</span>
                <span className={classNames('bs-collapsible-item__icon', { 'bs-collapsible-item__icon--open': isOpen })} aria-hidden />
            </button>

            {isOpen && (
                <div id={`${item.id}-content`} className='bs-collapsible-item__content'>
                    {item.renderAsHtml && typeof item.content === 'string' ? (
                        <div dangerouslySetInnerHTML={getHtmlString(item.content)} />
                    ) : (
                        item.content
                    )}
                    {item.appendedContent}
                </div>
            )}
        </div>
    );
};

type CollapsibleGroupProps = {
    items: CollapsibleItemData[];
    allowMultipleOpen?: boolean;
    className?: string;
};
export const CollapsibleGroup = ({ items, allowMultipleOpen = false, className }: CollapsibleGroupProps) => {
    const [openIds, setOpenIds] = useState<string[]>(items.filter(i => i.defaultOpen).map(i => i.id));

    const toggle = (id: string) => {
        setOpenIds(current => {
            const isOpen = current.includes(id);

            if (allowMultipleOpen) {
                return isOpen ? current.filter(x => x !== id) : [...current, id];
            }

            return isOpen ? [] : [id];
        });
    };

    return (
        <div className={classNames('bs-collapsible', className)}>
            {items.map(item => {
                const isOpen = openIds.includes(item.id);

                return <CollapsibleItem key={item.id} item={item} isOpen={isOpen} onToggle={toggle} />;
            })}
        </div>
    );
};
